import { useState } from "react";
import { getAllPacks } from "../db";
import { getDB } from "../db/schema";
import { Button } from "../components/Button";

/**
 * Export current IndexedDB content as JSON files identical to the format used
 * by /content/packs.json and /content/cards.json — drop them in public/content
 * to seed the next deploy.
 */
export default function AdminExport() {
  const [busy, setBusy] = useState(false);

  async function download(filename: string, json: unknown) {
    const blob = new Blob([JSON.stringify(json, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }

  async function exportPacks() {
    setBusy(true);
    try {
      const packs = await getAllPacks();
      // Strip runtime-only fields (totalCards/status/progressPct).
      const stripped = packs.map(
        ({ totalCards: _t, status: _s, progressPct: _p, ...rest }) => rest
      );
      await download("packs.json", stripped);
    } finally {
      setBusy(false);
    }
  }

  async function exportCards() {
    setBusy(true);
    try {
      const db = await getDB();
      const cards = await db.getAll("cards");
      cards.sort((a, b) => a.id.localeCompare(b.id));
      await download("cards.json", cards);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-col gap-3 pb-6">
      <h3 className="font-display text-lg font-bold">Експорт у seed</h3>
      <p className="text-xs opacity-70 leading-relaxed">
        Це міст між адмінкою (твій IDB) і реальним «сервером» — тобто файлами
        <code> public/content/*.json</code>, що деплояться на статичний хостинг.
        Поки колода тут (📝 чернетка) — її бачиш тільки ти. Щоб гравці теж
        побачили: жми Export, замінюй файли в <code>public/content/</code>,
        бампай <code>version</code>, комітьте, редеплой.
      </p>
      <div className="grid grid-cols-2 gap-3">
        <Button onClick={exportPacks} disabled={busy}>
          packs.json
        </Button>
        <Button onClick={exportCards} disabled={busy}>
          cards.json
        </Button>
      </div>
    </div>
  );
}
